import { initCarousel } from './../carousels/carousel';

export interface IVehicle {
	HeadingIconAlt: string;
	HeadingIconSrc: string;
	HeadingIconSrcSet: string;
	ID: string;
	Name: string;
	PassengerCapacity: number;
	PassengerIconAlt: string;
	PassengerIconSrc: string;
	PassengerSrcSet: string;
	PassengerLabel: string | null;
	ShowWheelchairInfo: false;
	VehicleCategories: IVehicleCategory[];
	WheelchairIconAlt: string | null;
	WheelchairIconSrc: string | null;
	WheelchairIconSrcSet: string | null;
	WheelchairLabel: string;
}

interface IVehicleCategory {
	BookingLinkTarget: string;
	BookingLinkText: string;
	BookingLinkUrl: string;
	Fare: string | null;
	FareFormat: string;
	FormattedFare: string;
	ID: string;
	Name: string;
}

/*const CAROUSEL_SELECTOR = '[data-taxi-and-limo-curator]';*/
const CAROUSEL_SELECTOR = '.taxi-and-limo-panel__carousel';

const DEFAULT_OPTIONS = {
	perPage: {
		1024: 4,
		768: 2,
		425: 1
	}
};

export default function main(data: IVehicle[]) {
	const curator = document.querySelector<HTMLElement>(CAROUSEL_SELECTOR);

	if (!curator || !data) {
		return;
	}

	//const elements = data.reduce((previousVehicle, currentVehicle) => {
	//	return previousVehicle + generateCard(currentVehicle);
	//}, '');

	//curator.innerHTML = elements;

	const slidesEl = curator.querySelector<HTMLElement>('.carousel__slides');
	if (!slidesEl) return;
	slidesEl.innerHTML = data.reduce((prev, curr) => prev + generateCard(curr), '');

	initCarousel(curator);
}

function generateCard(data: IVehicle): string {
	return `
		<div class="carousel__item">
			<div class="vehicle-card" id="${data.ID}">
				<div class="vehicle-card__main">
					<h2 class="vehicle-card__heading">${data.Name}</h2>
					<p class="vehicle-card__capacity">
						<picture class="vehicle-card__icon">
							<img src="${data.PassengerIconSrc}" ${data.PassengerIconAlt ? `alt="${data.PassengerIconAlt}"` : ''}/>
						</picture>${data.PassengerCapacity} ${data.PassengerLabel}
					</p>
					${
						data.ShowWheelchairInfo
							? `
						<p class="vehicle-card__wheelchair">
							<picture class="vehicle-card__icon">
								<img src="${data.WheelchairIconSrc}" ${data.WheelchairIconAlt ? `alt="${data.WheelchairIconAlt}"` : ''}/>
							</picture>
							${data.WheelchairLabel}
						</p>`
							: ''
					}
				</div>
				<div class="vehicle-card__footer">
					<ul class="vehicle-card__list">
						${data.VehicleCategories.reduce((prev, cur) => {
							return (
								prev +
								`
								<li class="vehicle-card__fare" id="${cur.ID}">
									<h3 class="vehicle-card__fare-heading">${cur.Name}</h3>
									<p class="vehicle-card__fare-price">${cur.FormattedFare}</p>
									${
										cur.BookingLinkUrl
											? `<a class="vehicle-card__link-button link-button link-button--uppercase" href="${cur.BookingLinkUrl}" target="${cur.BookingLinkTarget}">${cur.BookingLinkText}
										<svg width="13" height="9" xmlns="http://www.w3.org/2000/svg"><g stroke="#002663" fill="none" fillRule="evenodd"><path d="M0 4.2h12" /><path strokeLinecap="square" d="M7.8 0L12 4.2 7.8 8.4" /><path d="M0 4.2h12" /><path strokeLinecap="square" d="M7.8 0L12 4.2 7.8 8.4" /></g></svg>
									</a>`
											: ''
									}
								</li>
							`
							);
						}, '')}
					</ul>
				</div>
	
				<div class="vehicle-card__main-icon">
					<picture class="vehicle-card__picture">
						<img src="${data.HeadingIconSrc}" ${data.HeadingIconAlt ? `alt="${data.HeadingIconAlt}"` : ''}/>
					</picture>
				</div>
			</div>
		</div>
	`;
}
